import { animate, style, transition, trigger } from '@angular/animations';

export const TOOLTIP_FADE_ANIMATION = trigger('fadeInOut', [
  transition(':enter', [style({ opacity: '0' }), animate('150ms 250ms ease', style({ opacity: '*' }))]),
  transition(':leave', [animate('150ms ease', style({ opacity: 0 }))])
]);
